import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: "HtmlFilter"})
export class HtmlFilter implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: string) {
    let retStr: string = ('' + value).replace(/\\r\\n/g, '<br>').replace(/\r\n/g, '<br>').replace(/\\n/g, '<br>').replace(/\n/g, '<br>');
    return this.sanitizer.bypassSecurityTrustHtml(retStr);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/html.pipe.ts